import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RichTextEditor from "@Shared/utils/rich-text-editor";
import HTMLTextEvaluationMixin from "@Shared/utils/application-mixins/html-text-evaluation-mixin";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import Err from "@Broker/js/routes/error";
import { mapActions, mapGetters } from "vuex";
import { ADD_REFERRER_NOTE } from "@Broker/@Modules/clients/referrers/store/referrer-actions";
import { showToast } from "@Shared/utils/constants";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { REFERRER_CUSTOM_FIELDS_TAGS, REFERRER_CUSTOM_FIELDS_HINT_TAGS } from "@Broker/@Modules/clients/referrers/store/referrer-getters.ts";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerNoteTab",
  components: {
    SimpleButton
  },
  mixins: [HTMLTextEvaluationMixin],
  props: {
    referrer: {
      type: Object,
      default: () => ({})
    },
    referrerId: {
      type: [String, Number],
      required: true
    },
    currentTab: {
      type: String,
      required: true
    },
    external: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      createWithActivity: false,
      editor: null,
      note: "",
      loading: false,
      loadingSucceeded: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ReferrerStore", [REFERRER_CUSTOM_FIELDS_TAGS, REFERRER_CUSTOM_FIELDS_HINT_TAGS])), {}, {
    canSave() {
      return this.htmlToTextContent(this.note) !== "";
    },
    customFieldsTags() {
      return this.REFERRER_CUSTOM_FIELDS_TAGS(this.referrerId);
    },
    customFieldsHintsTags() {
      return this.REFERRER_CUSTOM_FIELDS_HINT_TAGS(this.referrerId);
    }
  }),
  watch: {
    customFieldsTags: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          mergeTags: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    customFieldsHintsTags: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          hints: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [ADD_REFERRER_NOTE])), {}, {
    init() {
      const target = $(this.$refs.referrerNoteField);
      this.editor = new RichTextEditor(target, {
        placeholder: this.$t("client-profile.messages.startTypingToLeaveNote"),
        airMode: true,
        height: "6vw",
        substitutionHints: true,
        showMergeTags: true,
        loadPreferences: false,
        visible: this.currentTab === "note",
        mergeTags: defaults => {
          return [...defaults, ...this.customFieldsTags];
        },
        hints: defaults => {
          return [...defaults, ...this.customFieldsHintsTags];
        },
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
      this.createWithActivity = false;
    },
    handleEditorChange(_, content) {
      this.note = content;
    },
    handleAddNote(createWithActivity) {
      this.createWithActivity = createWithActivity;
      this.handleSubmit();
    },
    async handleSubmit() {
      try {
        this.loading = true;
        const referrerNoteId = await this.ADD_REFERRER_NOTE({
          id: this.referrerId,
          note: this.editor.getHTML()
        });
        this.loadingSucceeded = true;
        showToast("success", "notedAdded");
        this.$emit("submit");
        $(this.$refs.referrerNoteField).val("");
        this.editor.setHTML("");
        this.note = "";
        if (this.createWithActivity) {
          showBModal("referrer-activity-convert-modal", {
            id: referrerNoteId,
            activityType: "note"
          }, this);
          this.$nextTick(() => {
            this.createWithActivity = false;
          });
        }
      } catch (e) {
        this.loadingSucceeded = false;
        Err.handle(e);
      } finally {
        this.loading = false;
      }
    }
  })
});